import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["createAnalyticsEvent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { DEFAULT_GAS_CHANNEL } from './events';
export function withAnalytics(analytics) {
  return function (Component) {
    var WrappedComponent = /*#__PURE__*/function (_React$Component) {
      function WrappedComponent() {
        var _this;
        _classCallCheck(this, WrappedComponent);
        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
          _args[_key] = arguments[_key];
        }
        _this = _callSuper(this, WrappedComponent, [].concat(_args));
        _defineProperty(_this, "wrappedAnalyticsCallback", Object.keys(analytics).reduce(function (acc, key) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, function () {
            _this.props.createAnalyticsEvent && _this.props.createAnalyticsEvent(analytics[key].apply(analytics, arguments)).fire(DEFAULT_GAS_CHANNEL);
          }));
        }, {}));
        return _this;
      }
      _inherits(WrappedComponent, _React$Component);
      return _createClass(WrappedComponent, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
            createAnalyticsEvent = _this$props.createAnalyticsEvent,
            rest = _objectWithoutProperties(_this$props, _excluded);

          // There is NOT typesafety for the next line as typescript cannot infer types correctly with spread operators.
          // This is just going to have to go without type safety for the next line.
          return /*#__PURE__*/React.createElement(Component, _extends({}, rest, this.wrappedAnalyticsCallback));
        }
      }]);
    }(React.Component);
    return withAnalyticsEvents()(WrappedComponent);
  };
}